// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","footer__socialIcon":"Footer_footer__socialIcon__jjfM0","copyright":"Footer_copyright__ySkOD"};